export default [
  {
    section: 'Klima und Energie',
    measures: [
      {
        name: 'Weiden West IV',
        info: '70ha Wald sollen für ein Industriegebiet mit fraglichem Mehrwert gefällt werden. Der Wald dient gerade den Menschen in Weiden West als wichtiges Naherholungsgebiet, verschiedenen Tier und Pflanzenarten als Rückzugsgebiet sowie als großer CO2-Speicher.',
        activityQuestion: 'Ich möchte den Wald in Weiden West erhalten',
        subquestionsActive: [
          {
            question: 'Warum ist mir das wichtig:',
            options: ['Naherholung', 'Freizeit und Sport', 'Beitrag zum Klima- und Artenschutz', 'Höhere Lebensqualität für Stadtbewohner', 'Ich befürchte in Zukunft mehr Verkehr (Pendler und Zubringer)'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Der Wald kann weg weil',
            options: ['mir Arbeitsplätze wichtiger als die Umwelt sind', 'West IV ist kein „wertvoller“ erhaltenswerter Wald', 'es gibt keine besseren Flächen für Industrie'],
            type: 'multi-select'
          }
        ]
      },
      {
        name: 'Industriegebiet Weiden West IV',
        info: '',
        activityQuestion: 'Mir ist das Industriegebiet wichtig',
        subquestionsActive: [
          {
            question:'Mir ist das Industriegebiet wichtig weil',
            options: ['Schaffung neuer Arbeitsplätze', 'Höhere Steuereinnahmen für die Stadt',  'Möglichkeit zur Ausbildung für junge Menschen'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question:'Mir ist das Industriegebiet nicht wichtig weil',
            options: ['Nur automatisierte Arbeitsplätze entstehen', 'Weiden anderweitig Jobs schaffen kann',  'Es nicht auf diesen Flächen gebaut werden sollte'],
            type: 'multi-select'
          }
        ]
      },          {
        name: 'Windräder',
        info: '',
        activityQuestion: 'Ich bin der Meinung, dass wir auch um Weiden Windräder bauen sollten',
        subquestionsActive: [
          {
            question: 'Stimme ich zu weil',
            options: ['Nutzung der Windenergie an sonnenarmen Tagen ist notwendig', 'Dezentrale Energieversorgung vor Ort', 'Weniger Abhängigkeit von großen Energielieferanten', 'Verhindern die HGÜ-Trassen.'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Ich bin gegen Windräder weil',
            options: ['Sie das Landschaftsbild massiv stören', 'Sie Bewohner in ihrer Ruhe stören könn', 'Töten vorbeifliegende Vögel', 'Sind teuer und störanfällig', 'Ich glaube ich muss dan mehr für meinen Strom bezahlen'],
            type: 'multi-select'
          }
        ]
      },
        {
        name: 'Grünanlagen',
        info: '',
        activityQuestion: 'Ich bin für einen Ausbau der Grünanlagen in Weiden',
        subquestionsActive: [
          {
            question: 'Ich bin dafür weil...',
            options: ['Blühflächen machen die Stadt und ihre Wohngebiete lebenswerter',   'Sind ein Beitrag zum Artenschutz',   'Führen zu einem besseren Klima in der Stadt',   'Ich bin Teil der Natur und möchte in ihr leben'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Ich will das nicht, weil...',
            options: ['Mehr Aufwand für städtische Mitarbeiter',
              'Höhere Kosten für die Stadt',
              'Wir haben sowieso zu wenige Parkplätze'],
            type: 'multi-select'
          }
        ]
      }
    ]
  },
  {
    section: 'Verkehr und Stadtplanung',
    measures: [
          {
        name: 'Nutzung ÖPNV',
        info: 'ÖPNV = Öffentlicher Personen Nah Verkehr',
        relevanceQuestion: 'Ich halte die Nutzung des ÖPNV für wichtig',
        activityQuestion: 'Ich nutze den ÖPNV',
        subquestionsActive: [
          {
            question: 'Ich nutze den ÖPNV...',
            options: ['Täglich', '2-3 Mal pro Woche', '<2 Mal pro Woche', '<4 pro Monat', 'Seltener'],
            type: 'single-select'
          },
          {
            question: 'Der Ausbau des Netzes ist...', 
            options: ['Perfekt, ich komme überall hin', 'Gut, ich muss nur selten Strecken zu Fuß gehen', 'in Ordnung, ich muss aber größere Strecken (500< m) zu Fuß gehen', 'Schlecht, für meine Zwecke ist der ÖPNV nicht alltagstauglich'],
            type: 'single-select'
          },
          {
            question: 'Die Preise des ÖPNV sind...',
            options: ['Angemessen', 'Noch in Ordnung', 'Grenzwertig', 'Zu hoch'],
            type: 'single-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Ich nutze den ÖPNV kaum oder gar nicht weil...',
            options: ['Ich lieber unabhängig bin von Fahrplänen', 'Meine Strecke nicht abgedeckt ist', 'Er zu teuer ist', 'Ich lieber mit meinem eigenen Auto fahre', 'Er unzuverlässig ist', 'Ich damit nicht komplett bis an mein Ziel komme', 'ich sperriges oder schweres so schlecht transportieren kann', 'es länger dauert', 'er häufig überfüllt ist'],
            type: 'multi-select'
          }
        ]
      },
      {
        name: 'Mobil mit eigener Kraft (keine Nutzung von Auto, Bahn, Flugzeug)',
        info: '',
        activityQuestion: 'Ich halte Fortbewegung aus eigener Kraft für wichtig',
        subquestionsActive: [
          {
            question: 'Den Großteil meiner täglichen Strecken bewältige ich...',
            options: ['Mit dem Fahrrad', 'Zu Fuß', 'mit dem E-Bike', 'mit dem Roller', 'mit dem E-Roller'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Ich nutze motorisierte Fahrzeug, weil...',
            options: ['die Strecken sonst zu lang sind', 'es sonst zu anstrengend wäre', 'ich sonst vom Wetter abhängig bin', 'Die Infrastruktur z.B. Fahrradwege nicht ausreichend ausgebaut sind', 'Mein Auto für mich ein Statussymbol ist', 'Fahrrad fahren zu gefährlich ist', 'ich sonst keine schweren Dinge transportieren kann'],
            type: 'multi-select'
          }
        ]
      },

      {
        name: 'Autofreier Monat',
        info: 'Lebensmittel die nach strengeren Kriterien angebaut werden (z.B. kein Einsatz von chemischen Unkrautbekämpfungsmitteln, mehr Platz für Tiere im Stall)',
        activityQuestion: 'Was halten Sie von einem autofreien Monat in ihrem Stadtgebiet?',
        subquestionsActive: [
          {
            question: 'Würde ich unterstützen, weil:',
            options: [   'Meine Kinder mal gefahrlos spielen könnten.', 'Ich öfter das Auto stehen lasse und den ÖPNV nutze', 'Meine Fenster bleiben länger offen  - endlich weniger Staub und Lärm', 'Wir mal ein Straßenfest feiern können.'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Gefällt mir überhaupt nicht:',
            options: ['Das ist ein Eingriff in meine individuelle Lebensweise',
              'Ich kann nicht auf mein Auto verzichten',
              'Die lokalen Firmen werden Kunden verlieren',
              'Mich besucht dann niemand mehr'],
            type: 'multi-select'
          }
        ]
      }
    ]
  },
  {
    section: 'Soziale Gerechtigkeit, Familie, Bildung, Mitbestimmung',
    measures: [
      {
        name: 'Ganztagsangebote an Schulen',
        info: '',
        activityQuestion: 'Soll das Ganztagesangebot für Schüler ausgebaut werden?',
        subquestionsActive: [
          {
            question: 'Ich bin dafür weil...',
            options: [
              'Weniger Stress zu Hause wegen der Hausaufgaben',
              'Wir können beide berufstätig sein',
              'Die Schule hat mehr Zeit kreative Lernprojekte umzusetzen.',
              'Die Qualität des Unterrichts steigt',
              'Die Klasse ist länger zusammen, das ist gut für das Sozialverhalten der Schüler'],
            type: 'multi-select'
          }        ],
        subquestionsInactive: [
          {
            question: 'Da bin ich dagegen:',
            options: ['Ich habe weniger Einfluss auf meine Kinder',
              'Meinen Kindern geht zu viel Freizeit verloren – Hobbys leiden darunter',
              'Die Schüler werden durch den Ganztag überfordert',
              'Es bleibt weniger Zeit für Freunde und Familie',
              'Die Qualität des Angebots stimmt oft nicht'],
            type: 'multi-select'
          }
        ]
      },
      {
        name: 'Treffpunkte für Kinder und Jugendliche',
        info: '',
        activityQuestion: 'Wir brauchen mehr Treffpunkte für Kinder und Jugendliche',
        subquestionsActive: [
          {
            question:'Das stimmt weil',
            options: ['Das „JUZ“ macht sicher tolle Angebote, aber von meinem Stadtteil ist mir das zu weit weg.',
              'Mehr „Aktivspielplätze“ wären schön.',
              'Die Zahl der Bolzplätze sollte erhöht werden',
              'Ich möchte mehr selbst mitbestimmen können, was für uns Jugendliche getan wird'],
            type: 'multi-select'
          }
        ],
        subquestionsInactive: [
          {
            question: 'Brauchen wir nicht weil',
            options: ['Das bedeutet mehr Lärm in unserem Wohngebiet',
              'Es gibt genügend Angebote: Feuerwehr, Sportvereine, Pfadfinder etc.',
              'Wer soll das alles bezahlen?',
              'Die vorhandenen Spielplätze sind für alle gut erreichbar'],
            type: 'multi-select'
          }
        ]
      }
    ]
  },
{
    section: 'Wirtschaft, Bauen und Wohnen',
    measures: [
      {
        name: 'Mehrgenerationenwohnprojekt',
        info: '',
        activityQuestion: 'Ich bin dafür, dass in Weiden ein Mehrgenerationenwohnprojekt entsteht?',
        subquestionsActive: [
          {
            question: 'Ich bin dafür weil...',
            options: [
               'Ich möchte so lange wie möglich in den eigenen vier Wänden wohnen bleiben.',
                'Endlich hätten wir jemand, der am Nachmittag unsere Kinder beaufsichtigen kann.',
                'Bei kleineren Reparaturen helfen wir uns gegenseitig',
                'Keine Einsamkeit im Alter'],
            type: 'multi-select'
          }        ],
        subquestionsInactive: [
          {
            question: 'Das will ich nicht:',
            options: [
            'Ist mir zu viel Nähe',
            'Verschwendung von Fördergeldern',
            'Meine Individualität geht verloren',
            'Ich bin kein Pflegepersonal für meine Nachbarn'],
            type: 'multi-select'
          }
        ]
      }    ]
  }

]
